'use client';

import type { ReactNode } from 'react';

import {
  HydrationBoundary,
  QueryClientProvider,
  type DehydratedState,
} from '@tanstack/react-query';

import { getQueryClient } from 'src/lib/react-query/query-client';

type ReactQueryProviderProps = {
  children: ReactNode;
  state?: DehydratedState;
};

export function ReactQueryProvider({ children, state }: ReactQueryProviderProps) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={state}>{children}</HydrationBoundary>
    </QueryClientProvider>
  );
}
